import { render, staticRenderFns } from "./SummaryAndConclusion.vue?vue&type=template&id=5123046e&scoped=true"
import script from "./SummaryAndConclusion.vue?vue&type=script&lang=js"
export * from "./SummaryAndConclusion.vue?vue&type=script&lang=js"
import style0 from "./SummaryAndConclusion.vue?vue&type=style&index=0&id=5123046e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123046e",
  null
  
)

export default component.exports